const root = ['sop-synthesizer'] as const;

export const sopKeys = {
  all: root,
  videos: () => [...root, 'videos'] as const,
  list: () => [...root, 'sops'] as const,
  detail: (id: string) => [...root, 'sops', id] as const,
} as const;
